import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import BedrockHowToApply from './bedrock';
import FsmHowToApply from './fsm';

const HowToApply = () => {
  const { isBedrock } = useAuthenticatedContextProvider();

  if (isBedrock) {
    return <BedrockHowToApply />;
  }

  return <FsmHowToApply />;
};

export default HowToApply;
